import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import Sesion from "../../Contexts/Sesion"
import BleProveedor from "../../Contexts/Ble/Proveedor"

const Base=()=>{
    return <Sesion.SesionProveedor>
    <BleProveedor>
    <Layout style={{minHeight:'100vh'}}>
        <Outlet/>
    </Layout>
    </BleProveedor>
</Sesion.SesionProveedor>
   
}

export default Base